import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

// Translation files
import zhCn from "../../public/locales/zh-cn.json";
import zhTw from "../../public/locales/zh-tw.json";
import cs from "../../public/locales/cs.json";
import da from "../../public/locales/da.json";
import nl from "../../public/locales/nl.json";
import en from "../../public/locales/en.json";
import fi from "../../public/locales/fi.json";
import fr from "../../public/locales/fr.json";
import de from "../../public/locales/de.json";
import it from "../../public/locales/it.json";
import ja from "../../public/locales/ja.json";
import ko from "../../public/locales/ko.json";
import nb from "../../public/locales/nb.json";
import pl from "../../public/locales/pl.json";
import ptBr from "../../public/locales/pt-br.json";
import pt from "../../public/locales/pt.json";
import es from "../../public/locales/es.json";
import sv from "../../public/locales/sv.json";
import th from "../../public/locales/th.json";
import tr from "../../public/locales/tr.json";

const resources = {
  "zh-cn": { translation: zhCn },
  "zh-tw": { translation: zhTw },
  cs: { translation: cs },
  da: { translation: da },
  nl: { translation: nl },
  en: { translation: en },
  fi: { translation: fi },
  fr: { translation: fr },
  de: { translation: de },
  it: { translation: it },
  ja: { translation: ja },
  ko: { translation: ko },
  nb: { translation: nb },
  pl: { translation: pl },
  "pt-br": { translation: ptBr },
  pt: { translation: pt },
  es: { translation: es },
  sv: { translation: sv },
  th: { translation: th },
  tr: { translation: tr },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Pin the initial language so SSR and the first client render are
    // deterministic ("en") and hydration matches. LanguageProvider switches
    // to the visitor's saved language after hydration.
    lng: "en",
    fallbackLng: "en",
    debug: false,

    // Language detection configuration
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
      lookupLocalStorage: "keystone-language",
    },

    // Prevent flash of default language
    react: {
      useSuspense: false,
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Namespace configuration
    defaultNS: "translation",
    ns: ["translation"],
  });

export default i18n;
